import React from "react";
import { Alert, Typography } from "@mui/material";
import { isDevEnvironment } from "utils/isDevEnvironment";

/**
 * MfaDevHint — dev-only helper for testing MFA without a real device.
 *
 * Firebase Auth test phone numbers (configured in the Auth console) return a fixed
 * verification code and send no real SMS, so a tester can enroll AND sign in
 * repeatedly with the test number instead of a real phone or authenticator app.
 *
 * Renders nothing in production (isDevEnvironment gate), so it is safe to ship.
 *
 * NOTE: only works when the account enrolled the test phone number below. TOTP has
 * no test-code bypass — enroll via the SMS test number for painless repeat sign-ins.
 */
const MfaDevHint = ({ sx }) => {
  if (!isDevEnvironment()) return null;
  return (
    <Alert severity="info" sx={{ mb: 2, ...sx }}>
      <Typography variant="body2">
        Testing only: if this account enrolled the test phone number{" "}
        <strong>+12623333333</strong>, enter code <strong>333333</strong>. No real SMS is sent.
      </Typography>
    </Alert>
  );
};

export default MfaDevHint;
